<template>
  <v-footer
    class="ctk-footer"
  >
    <template>
      <v-container grid-list-md text-center>
        <v-layout wrap>
          <v-flex xs12 sm12 md12 lg12 class="hidden-sm-and-down">
            <v-layout wrap>
              <v-flex md6 lg6 text-left>
                <div class="footer-qrcode">
                  <img width="100" :src="info.qrcode" />
                </div>
                <div class="footer-qrcode-title">关注我们</div>
              </v-flex>
              <v-flex md6 lg6 pl-12 text-left>
                <div><span class="footer-title">电话</span><span class="footer-value">{{info.tel}}</span></div>
                <div><span class="footer-title">邮箱</span><span class="footer-value">{{info.email}}</span></div>
                <div><span class="footer-title">地址</span><span class="footer-value">{{info.addr}}</span></div>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 text-center class="footer-copyright">
            &copy;2022 玛娅（上海）家居有限公司 | <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">备案号: {{info.icp}}</a>
          </v-flex>
        </v-layout>
      </v-container>
    </template>
  </v-footer>
</template>
<script>
export default {
  data: () => ({
  }),
  computed: {
    info () {
      let links = []
      if (this.$store.getters.companyInfo.link) {
        links = this.$store.getters.companyInfo.link.filter(ele => ele.type === 0)
      }
      let info = this.$store.getters.companyInfo
      info.links = links
      return info
    }
  }
}
</script>
